// extracted by mini-css-extract-plugin
export default {"messageLink":"FileView_messageLink__4OExA","messageImages":"FileView_messageImages__kCj4D","imageFrame":"FileView_imageFrame__F7dmM","audioMessage":"FileView_audioMessage__06jd3"};